import { SVGProps } from '../types';

const DefaultIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M31.3332 14.3333H14.6665M22.1665 17.6666H17.9998M14.6665 12.8333L14.6665 19.1666C14.6665 20.1 14.6665 20.5668 14.8482 20.9233C15.0079 21.2369 15.2629 21.4918 15.5765 21.6516C15.933 21.8333 16.3997 21.8333 17.3332 21.8333L28.6665 21.8333C29.5999 21.8333 30.0666 21.8333 30.4232 21.6516C30.7368 21.4918 30.9917 21.2369 31.1515 20.9233C31.3332 20.5668 31.3332 20.1 31.3332 19.1666V12.8333C31.3332 11.8999 31.3332 11.4332 31.1515 11.0766C30.9917 10.763 30.7368 10.5081 30.4232 10.3483C30.0666 10.1666 29.5999 10.1666 28.6665 10.1666L17.3332 10.1666C16.3998 10.1666 15.933 10.1666 15.5765 10.3483C15.2629 10.5081 15.0079 10.763 14.8482 11.0766C14.6665 11.4332 14.6665 11.8999 14.6665 12.8333Z"
      stroke="#6D6963"
      stroke-width="1.45833"
      stroke-linecap="square"
    />
  </svg>
);

export { DefaultIcon };
